function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9-101l5.055 7.899C20.26-83.408 18.07-70.585 9-63.5 2.096-58.107.872-48.138 6.266-41.234A15.862 15.862 0 009-38.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019-13.5C2.096-8.107.872 1.862 6.266 8.766A15.862 15.862 0 009 11.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019 36.5C2.096 41.893.872 51.862 6.266 58.766A15.862 15.862 0 009 61.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019 86.5c-6.904 5.393-8.128 15.362-2.734 22.266A15.862 15.862 0 009 111.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019 136.5c-6.904 5.393-8.128 15.362-2.734 22.266A15.862 15.862 0 009 161.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019 186.5c-6.904 5.393-8.128 15.362-2.734 22.266A15.862 15.862 0 009 211.5c6.904 5.393 8.128 15.362 2.734 22.266A15.862 15.862 0 019 236.5c-6.904 5.393-8.128 15.362-2.734 22.266A15.862 15.862 0 009 261.5c9.07 7.085 11.259 19.908 5.055 29.601L9 299",
  stroke: "#000",
  strokeWidth: 4,
  fill: "none",
  strokeLinecap: "square"
});

function SvgWavyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 302"
  }, props), _ref);
}

export default SvgWavyLine;